export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
  /** Where the quote comes from, shown as a pill (voice-of-customer cards). */
  source?: string
  /** City and country, shown under the role. */
  location?: string
}

/** Instructor testimonials about teaching with Bollywood Class Ready. */
export const instructorReviews: Testimonial[] = [
  {
    quote:
      'I used to start planning my Bollywood class with a blank page every week. Having the lesson structure and counts laid out gives me a starting point instead of building everything from scratch.',
    author: 'Kavya S. Rao',
    role: 'Bollywood Dance & Fitness Instructor',
    location: 'San Francisco, CA, United States',
  },
  {
    quote:
      "My beginner and recreational students don't always need the same level of challenge. Having variations in the lesson plan makes it easier to adapt the same class to different abilities.",
    author: 'Riya P. Malhotra',
    role: 'Bollywood Dance Workshop Instructor',
    location: 'Atlanta, GA, United States',
  },
  {
    quote:
      'When I teach kids, I need more than a choreography. I need a class that keeps them involved. Having games, cues and a clear sequence gives me more to work with.',
    author: 'Tara N. Shah',
    role: 'Bollywood Dance Teacher',
    location: 'Austin, TX, United States',
  },
  {
    quote:
      'I noticed that my beginner students needed fewer reminders once we started practicing the sequence in smaller eight-count sections.',
    author: 'Simran K. Gill',
    role: 'Bollywood Dance Instructor for Kids & Teens',
    location: 'Seattle, WA, United States',
  },
  {
    quote:
      'The kids responded well to having a clear activity to work on. The games gave me another way to bring their attention back to the lesson.',
    author: 'Aisha R. Verma',
    role: 'Bollywood Dance Instructor',
    location: 'London, United Kingdom',
  },
  {
    quote:
      'I could use the same basic sequence with different difficulty levels, so my recreational group could work on the same goal without everyone doing exactly the same thing.',
    author: 'Maya S. Anand',
    role: 'Bollywood Dance Teacher & Choreographer',
    location: 'Birmingham, United Kingdom',
  },
]

/**
 * Public comments by dance teachers about how they plan (from the DPS 40 product research).
 * They are NOT reviews of this pack. Swap in real buyer reviews (with permission) as they arrive.
 */
export const askedFor: Testimonial[] = [
  {
    quote: 'I write down all my dance steps!',
    author: 'Nina Kay, dance instructor',
    role: 'On how she keeps track of her routines',
    source: 'zindacademy.com',
  },
  {
    quote: '…my own secret language.',
    author: 'Nina Kay, dance instructor',
    role: 'On the mix of symbols, letters and numbers she uses to write routines',
    source: 'zindacademy.com',
  },
]

export const tiredOf: Testimonial[] = [
  {
    quote: 'As dancers we feel like we need to keep doing more and more.',
    author: 'Jenna Eberhardt, studio director',
    role: 'On the pressure to keep producing material',
    source: 'dance-teacher.com',
  },
  {
    quote: '…so that dancers aren’t feeling stuck in any one style.',
    author: 'Blake Piatczyc, studio director',
    role: 'On varying styles for students',
    source: 'dance-teacher.com',
  },
]
